import { render } from "./ContentCardBrowser.vue?vue&type=template&id=bdb04ae8&scoped=true"
import script from "./ContentCardBrowser.vue?vue&type=script&lang=js"
export * from "./ContentCardBrowser.vue?vue&type=script&lang=js"

import "./ContentCardBrowser.vue?vue&type=style&index=0&id=bdb04ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb04ae8"]])

export default __exports__